import React, { useState } from "react";
import CampaignList from "./CampaignList";
import CampaignBuilder from "./CampaignBuilder";
import CampaignAnalytics from "./CampaignAnalytics";

const CampaignTab = ({ stages, admins }) => {
    const [view, setView] = useState("list");
    const [selectedId, setSelectedId] = useState(null);

    const handleNew = () => {
        setSelectedId(null);
        setView("builder");
    };

    const handleEdit = (id) => {
        setSelectedId(id);
        setView("builder");
    };
    
    const handleAnalytics = (id) => {
        setSelectedId(id);
        setView("analytics");
    };

    const handleSave = () => {
        setView("list");
        setSelectedId(null);
    };

    const handleBack = () => {
        setView("list");
        setSelectedId(null);
    };

    if (view === "builder") {
        return (
            <CampaignBuilder
                campaignId={selectedId}
                stages={stages}
                admins={admins}
                onSave={handleSave}
                onCancel={handleBack}
            />
        );
    }

    if (view === "analytics") {
        return (
            <CampaignAnalytics
                campaignId={selectedId}
                onBack={handleBack}
            />
        );
    }

    return (
        <CampaignList
            onNew={handleNew}
            onEdit={handleEdit}
            onAnalytics={handleAnalytics}
        />
    );
};

export default CampaignTab;
